function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import LineGraph from './line-graph';
import { lineGraphHeight } from '../allhomes-listing-suburb-stats.style';
import * as styles from './unimproved-value.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var UnimprovedValue = _ref => {
  var unimprovedValues = _ref.unimprovedValues,
    disableAnimation = _ref.disableAnimation,
    height = _ref.height;
  // Colours need to be resolved only during client-side render.
  var _useState = useState({
      resolved: false,
      uvRoundelColour: '#000'
    }),
    _useState2 = _slicedToArray(_useState, 2),
    colours = _useState2[0],
    setColours = _useState2[1];
  useEffect(() => {
    if (!colours.resolved) {
      setColours({
        resolved: true,
        uvRoundelColour: styles.uvRoundelColour()
      });
    }
  }, [colours.resolved]);
  return ___EmotionJSX(LineGraph, {
    data: {
      labels: unimprovedValues.map(_ref2 => {
        var year = _ref2.year;
        return "".concat(year);
      }).reverse(),
      datasets: [{
        label: 'Unimproved value',
        data: unimprovedValues.map(_ref3 => {
          var value = _ref3.value;
          return value;
        }).reverse()
      }]
    },
    colours: [colours.uvRoundelColour],
    options: {
      disableAnimation
    },
    height: height
  });
};
UnimprovedValue.propTypes = {
  unimprovedValues: PropTypes.arrayOf(PropTypes.shape({
    year: PropTypes.number,
    value: PropTypes.number,
    formatted: PropTypes.string
  })),
  height: PropTypes.number,
  disableAnimation: PropTypes.bool
};
UnimprovedValue.defaultProps = {
  unimprovedValues: [],
  height: lineGraphHeight,
  disableAnimation: false
};
export default UnimprovedValue;